export enum __typename {
  Amenity = "Amenity",
  AmenityTranslation = "AmenityTranslation",
  CalculateCartPayload = "CalculateCartPayload",
  Cart = "Cart",
  Country = "Country",
  Image = "Image",
  MandatoryExtra = "MandatoryExtra",
  OptionalExtra = "OptionalExtra",
  RateGroup = "RateGroup",
  RateGroupTranslation = "RateGroupTranslation",
  RatePlan = "RatePlan",
  RatePlanTranslation = "RatePlanTranslation",
  Reservation = "Reservation",
}
